<!--
 * @description: 搜索表格
 * @author: Oli
 * @date: 2023/4/13 17:16
-->

<template>
  <ls-search-form ref="searchForm" :formList="formList" @search="onSearch">
  </ls-search-form>
</template>

<script>

export default {
  name: 'SearchInput',
  props: {
    // 发布人列表
    publishUserList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 报名人列表
    applyUserList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      formList: [
        {
          label: '表名称',
          type: 'input',
          decorator: ['tableName']
        },
        {
          label: '表描述',
          type: 'input',
          decorator: ['tableComment']
        },
        {
          label: '创建时间',
          type: 'range',
          decorator: [`dateRange`],
          disposeFormat: {
            publishDateStart: (change) => {
              return change[0].format('YYYY-MM-DD 00:00:00')
            },
            publishDateEnd: (change) => {
              return change[1].format('YYYY-MM-DD 23:59:59')
            }
          }
        }
      ]
    }
  },
  methods: {
    onSearch (val) {
      this.$emit('search', val)
    },
    setValue (val) {
      this.$refs.searchForm.form.setFieldsValue(val)
    }
  }
}
</script>
